import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetPlayerListRequest, GetPlayerListResponse } from '../type/types';

// 나의 플레이어 목록 조회
export const getPlayerList = async (params: GetPlayerListRequest) => {
  const query = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== undefined && v !== null && v !== ''
    )
  );
  const res = await api.get<ApiResponseType<GetPlayerListResponse>>(
    `/api/web/partners/players/search`,
    { params: query }
  );
  return res.data;
};
